import React, { ComponentPropsWithoutRef, ElementType, ReactNode } from "react";
import styled from "styled-components";
import { tombac } from "../../shared/tombac";
import { TomTomLogo } from "../Symbols/TomTomLogo";

export type NavbarLogoProps<T extends ElementType> = {
  as?: T;
  title?: ReactNode;
} & Omit<ComponentPropsWithoutRef<T>, "title">;

const Container = styled.div`
  all: initial;

  align-items: center;
  align-self: center;
  display: flex;
  padding: ${tombac.space(0, 3)};

  a&,
  button& {
    cursor: pointer;
  }

  @media (min-width: ${tombac.unit(960)}) {
    padding: ${tombac.space(0, 5)};
  }

  @media (min-width: ${tombac.unit(1280)}) {
    padding: ${tombac.space(0, 10)};
  }
`;

const Logo = styled(TomTomLogo)`
  height: ${tombac.unit(18)};

  @media (min-width: ${tombac.unit(768)}) {
    height: ${tombac.unit(24)};
  }
`;

const Title = styled.span`
  all: initial;

  align-items: center;
  border-left: ${tombac.parse("1u solid --neutral-400")};
  cursor: inherit;
  display: flex;
  height: ${tombac.unit(28)};
  margin-left: ${tombac.space(3)};
  padding-left: ${tombac.space(3)};

  ${tombac.text()}
`;

export function NavbarLogo<T extends ElementType = "div">({
  title,
  ...rest
}: NavbarLogoProps<T>) {
  return (
    <Container {...(rest as any)}>
      <Logo />
      {title && <Title>{title}</Title>}
    </Container>
  );
}
